export default {
  appointment: 'Termin',
  at: 'in',
  back: 'zurück',
  closed: 'geschlossen',
  emergency: 'Notfälle',
  'except-kids': 'nicht für Kinder verfügbar',
  'except-treatment': 'Behandlung nicht möglich',
  for: 'für',
  form: {
    fields: {
      firstName: 'Vorname',
      lastName: 'Name',
      phone: 'Telefon',
      email: 'E-Mail',
    },
    validation: {
      firstName: {
        required: 'Vorname ist erfolderlich',
      },
      lastName: {
        required: 'Name ist erfolderlich',
      },
      phone: {
        required: 'Telefon ist erfolderlich',
      },
      email: {
        required: 'E-Mail ist erfolderlich',
        email: 'Geben Sie eine gültige E-Mail-Adresse',
      },
    },
  },
  'i-am-a-new-patient': 'Ich bin ein neuer Patient',
  'i-wish': 'Ich wünsche eine Konsultation',
  infos: 'Infos',
  message: 'Nachricht',
  'my-appointment-in': 'mein Termin in',
  'my-appointment-for': 'mein Termin für',
  no: 'nein',
  open: 'offen',
  personTypes: {
    adult: 'Erwachsene (ab 18 Jahre)',
    kid: 'Kinder (bis 15 Jahre)',
    teenager: 'Jugendliche (16-18 Jahre)',
  },
  send: 'senden',
  step4: {
    infos: 'Indem Sie auf "Senden" klicken, schicken Sie uns Ihre Terminanfrage. Fügen Sie hier einen Kommentar hinzu, wenn Sie möchten (z. B. eine bevorzugte Uhrzeit, den Namen eines Zahnarztes, den Sie für Ihre Behandlung wünschen, oder andere Informationen, die für Ihre Terminanfrage relevant sind).',
    'see-you-soon': 'bis bald',
    signature: 'Team Adent',
    'thank-you': 'Wir haben Ihre Nachricht erhalten. Wir werden uns in Kürze mit Ihnen in Verbindung setzen, um Ihnen einen Termin gemäss Ihrer Anfrage anzubieten. Bis bald!',
    'you-can-leave': 'Sie können dieses Fenster jetzt verlassen.',
  },
  'take-appointment': 'Termin vereinbaren',
  'there-for-you': 'wir sind für Sie da',
  where: 'wo',
  yes: 'ja',
}
